"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CMS: 'cms',
  HUB_MARKETING: 'marketing',
  HUB_SALES: 'sales',
  HUB_SERVICE: 'service',
  HUB_CMS: 'cmsHub'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/Hubs.js
// module id = 21
// module chunks = 5 6 7